import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const BUTTERFLIES = ["🦋", "🌸", "🦋", "🦋"];

export function Butterflies({ count = 16 }: EffectProps = {}) {
  const items = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        char: pick(BUTTERFLIES),
        top: `${rand(5, 90)}vh`,
        size: `${rand(22, 44)}px`,
        crossDuration: `${rand(12, 22)}s`,
        delay: `${rand(-22, 0)}s`,
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {items.map(b => (
        <span
          key={b.id}
          className="fx-particle fx-butterfly"
          style={
            {
              top: b.top,
              fontSize: b.size,
              animationDuration: b.crossDuration,
              animationDelay: b.delay,
            } as CSSProperties
          }
        >
          {b.char}
        </span>
      ))}
    </div>
  );
}
